import { create } from 'zustand';
import LocalStorageSvc from '../common/localStorageSvc';

const ADMIN_SITE_KEY = 'ADMIN_SELECTED_SITE';

export type AdminSiteContextType = {
    adminSiteId: number | null;
    setAdminSiteId: (id: number | null) => void;
};

const stored = LocalStorageSvc.load<number>(ADMIN_SITE_KEY);

const useAdminSiteContext = create<AdminSiteContextType>((set) => ({
    adminSiteId: stored ?? null,
    setAdminSiteId: (id: number | null) => {
        if (id !== null) {
            LocalStorageSvc.save<number>(ADMIN_SITE_KEY, id);
        } else {
            LocalStorageSvc.remove(ADMIN_SITE_KEY);
        }
        set({ adminSiteId: id });
    },
}));

export default useAdminSiteContext;
